import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { BatchDataForm } from '../../../app/models/Batch';
import BatchForm from './forms/BatchForm';

type SelectOpt = { id: number | string; name: string };

interface Props {
  fetching?: boolean;
  action: () => void;
  cancel: () => void;
  batch: BatchDataForm;
  setBatch: (data: BatchDataForm) => void;
  projects: SelectOpt[];
  setProjects: (opts: SelectOpt[]) => void;
  centers: SelectOpt[];
  setCenters: (opts: SelectOpt[]) => void;
  units: SelectOpt[];
  setUnits: (opts: SelectOpt[]) => void;
  batchCategories: SelectOpt[];
  setBatchCategories: (opts: SelectOpt[]) => void;
  societies: SelectOpt[];
  setSocieties: (opts: SelectOpt[]) => void;
  warehouses: SelectOpt[];
  setWarehouses: (opts: SelectOpt[]) => void;
  products: SelectOpt[];
  setProducts: (opts: SelectOpt[]) => void;
  errorFields?: any;
  disabled?: boolean; // ← Cambiado de readOnly a disabled
}

const BatchFormContainer = ({
  fetching,
  action,
  cancel,
  batch,
  setBatch,
  projects,
  centers,
  units,
  batchCategories,
  societies,
  warehouses,
  products,
  errorFields = null,
  disabled = false // ← Cambiado de readOnly a disabled
}: Props) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <BatchForm
            batchDataForm={batch}
            setBatchDataForm={setBatch}
            projects={projects}
            centers={centers}
            units={units}
            batchCategories={batchCategories}
            societies={societies}
            warehouses={warehouses}
            products={products}
            errorFields={errorFields}
            disabled={disabled} // ← Pasar disabled al formulario
          />
        </div>
      </div>
      
      {/* Ocultar botones en modo disabled */}
      {!disabled && (
        <>
          <hr />
          <div className="row justify-content-end">
            <div className="col-auto">
              <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
            </div>
            <div className="col-auto">
              <ButtonSaveForm callbackSave={action} locked={fetching} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BatchFormContainer;